import type { App, Component } from 'vue';
import {
  TextField,
  NumberField,
  TextareaField,
  FileField,
  RadioField,
  RadioGroup,
  ComboboxField,
  SearchAndSelectField,
  OtpField,
} from '@/common/components/form';
import BaseButton from '@/common/components/zvdzo/BaseButton.vue';
import BaseDialog from '@/common/components/zvdzo/BaseDialog.vue';
import BaseForm from '@/common/components/zvdzo/BaseForm.vue';
import BaseAlert from '@/common/components/zvdzo/BaseAlert.vue';
import BaseCard from '@/common/components/zvdzo/BaseCard.vue';
import FieldSet from '@/common/components/form/FieldSet.vue';
import ThePageTitle from '@/common/components/ThePageTitle.vue';
import TheTitleBar from '@/common/components/zvdzo/TheTitleBar.vue';
import SearchField from '@/common/components/zvdzo/SearchField.vue';
import BasePage from '@/common/components/zvdzo/BasePage.vue';
import CheckboxField from '@/common/components/form/CheckboxField.vue';
import DateField from '@/common/components/form/DateField.vue';
import TimeField from '@/common/components/form/TimeField.vue';
import Markdown from '@/common/components/Markdown.vue';
import SelectField from '@/common/components/form/SelectField.vue';
import BaseRouterLink from '@/common/components/zvdzo/BaseRouterLink.vue';
import BaseLinearLoader from '@/common/components/zvdzo/BaseLinearLoader.vue';

const components = {
  ThePageTitle,
  TheTitleBar,
  TextField,
  NumberField,
  TextareaField,
  FileField,
  RadioField,
  RadioGroup,
  ComboboxField,
  SearchAndSelectField,
  BaseForm,
  FieldSet,
  BaseAlert,
  BaseButton,
  BaseCard,
  BaseDialog,
  BasePage,
  CheckboxField,
  SearchField,
  DateField,
  TimeField,
  SelectField,
  OtpField,
  Markdown,
  BaseRouterLink,
  BaseLinearLoader,
};

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    ThePageTitle: typeof ThePageTitle;
    TheTitleBar: typeof TheTitleBar;
    BaseAlert: typeof BaseAlert;
    BaseButton: typeof BaseButton;
    BaseDialog: typeof BaseDialog;
    BaseCard: typeof BaseCard;
    BasePage: typeof BasePage;
    BaseForm: typeof BaseForm;
    FieldSet: typeof FieldSet;
    TextField: typeof TextField;
    NumberField: typeof NumberField;
    TextareaField: typeof TextareaField;
    FileField: typeof FileField;
    RadioField: typeof RadioField;
    RadioGroup: typeof RadioGroup;
    ComboboxField: typeof ComboboxField;
    SearchAndSelectField: typeof SearchAndSelectField;
    CheckboxField: typeof CheckboxField;
    SearchField: typeof SearchField;
    DateField: typeof DateField;
    TimeField: typeof TimeField;
    SelectField: typeof SelectField;
    OtpField: typeof OtpField;
    Markdown: typeof Markdown;
    BaseRouterLink: typeof BaseRouterLink;
    BaseLinearLoader: typeof BaseLinearLoader;
  }
}

export default {
  install: (app: App<Element>) => {
    Object.entries(components).forEach(([key, component]) => {
      app.component(key, component as Component);
    });
  },
};
